import { render, staticRenderFns } from "./flats-card-resize-elem.vue?vue&type=template&id=7551d201"
import script from "./flats-card-resize-elem.vue?vue&type=script&lang=js"
export * from "./flats-card-resize-elem.vue?vue&type=script&lang=js"
import style0 from "./flats-card-resize-elem.vue?vue&type=style&index=0&id=7551d201&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports